import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPepsiComponent } from './simple-icons-pepsi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPepsiComponent ],
    exports:      [ SimpleIconsPepsiComponent ],
    bootstrap:    []
})
export class SimpleIconsPepsiModule {}
